import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { VisitorsNumbersByCampaignGraph } from "../../../../components/Graphs/graphs";
import {
  SelectUTMCampaignStatus,
  SelectVisitors,
  SelectPercentBooking,
  SelectPercentBought,
  SelectWeeks,
  SelectLabels,
  graphUTMCampaign,
} from "./utmCampaignSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";

const UTMCampaign = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];

  // const UTMCampaignData = useSelector((state) => state.utmCampaign);
  const loading = useSelector(SelectUTMCampaignStatus);
  const weeks = useSelector(SelectWeeks);
  const visitors = useSelector(SelectVisitors);
  const percentBooking = useSelector(SelectPercentBooking);
  const percentBought = useSelector(SelectPercentBought);
  const adsLabels = useSelector(SelectLabels);

  useEffect(() => {
      if (!user) return null;
      if(weeks.length===0) dispatch(graphUTMCampaign(user));
  }, [user, weeks]);

  if (loading === "loading") return <SingleGraphLoading />;
  return (
    <VisitorsNumbersByCampaignGraph
      loading={loading === "loading"}
      display={display}
      weeks={weeks}
      visitors={visitors}
      percentOfBooking={percentBooking}
      nameLabels={adsLabels}
      totalSales={percentBought}
    />
  );
};

export default UTMCampaign;